<template>
  <v-footer app>
    <footer class="footer text-center">
      All Rights Reserved by Xtreme Admin. Designed and Developed by
      <a href="https://wrappixel.com">WrapPixel</a>.
    </footer>
  </v-footer>
</template>

<script>
export default {
  name: "vue-footer"
}
</script>
